import { useEffect } from 'react';

export const useOnWindowFocus = (onFocus: () => void) => {
  useEffect(() => {
    window.addEventListener('focus', onFocus);

    return () => window.removeEventListener('focus', onFocus);
  }, []);
};
